/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Loading from "./Loading";
import { useContext } from "react";
import { Dashboard2Context } from "./dashboard2";
import fetchHelper from "../services/fetchHelper";
import PatientNotes from "../components/PatientNotesForm/Notes";
import savingSpinner from "../assets/esign-ui-icons/saving-ico-white.svg";
import "./note.scss";

const Note = () => {
  const { userInfo } = useContext(Dashboard2Context);
  const [loading, setLoading] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [showFormNotes, setShowFormNotes] = useState(false);
  const [patientNotes, setPatientNotes] = useState([]);

  useEffect(() => {
    if (userInfo) {
      fetchPatientNotes();
    }
  }, [userInfo]);

  const fetchPatientNotes = async () => {
    setLoading(true);
    try {
      const url = encodeURI(
        `/patientmanagement/rest/patientnote?where={"patient.id":{"$eq": ${userInfo.patient.id} }}&sort=-sticky,-noteDate`
      );
      const response = await fetchHelper.get({ url });
      setPatientNotes(response);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const callbackNotes = async (action) => {
    switch (action) {
      case "cancel":
        setIsCancel(false);
        break;
      case "submit":
        await fetchPatientNotes();
        setIsSubmit(false);
        setShowFormNotes(false);
        break;
      default:
        setLoading(false);
        setIsCancel(false);
        setIsSubmit(false);
        break;
    }
  };

  return (
    <div id="note-section-container">
      <div id="note-section" className="notesSection tabContent selected">
        <div className="sbContent sb-notes">
          <div>
            <div className="axnBtn content-btn">
              {!showFormNotes ? (
                <button
                  className="btn btnTeal"
                  onClick={() => {
                    setShowFormNotes(true);
                  }}
                >
                  <i className="ti ti-plus" /> Create Note
                </button>
              ) : (
                <>
                  <button
                    className="btn btnTeal"
                    onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      setIsSubmit(true);
                    }}
                  >
                    {loading ? (
                      <img id="loading-spinner-4" src={savingSpinner} style={{ width: 15 }} />
                    ) : (
                      "Save"
                    )}
                  </button>
                  <button
                    className="btn"
                    onClick={() => {
                      setIsCancel(true);
                      setShowFormNotes(false);
                    }}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
            <h3>Patient Notes</h3>
            {showFormNotes ? (
              <PatientNotes isCancel={isCancel} isSubmit={isSubmit} callback={callbackNotes} />
            ) : null}

            {!loading ? (
              <ul className="patient-notes" id="ir-patient-notes">
                {patientNotes.map((item) => {
                  return (
                    <li key={item.id}>
                      <div className="notes-li">
                        <p>
                          {dayjs(item.noteDate).format("YYYY-MM-DD")} -{" "}
                          <strong>{`${item.user.family}, ${item.user.name}`}</strong>
                        </p>
                        <p>{item.note}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <>
                <Loading />
                <Loading />
                <Loading />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Note;
